<template>
  <div class="d-flex align-self-center">
    <nav-link
      to="/feedback"
      :title="$t('navigation_bar.feedback')"
      class="mx-4"
    />

    <nav-link
      to="/"
      :title="$t('navigation_bar.templates')"
      class="mx-4"
    />
    <v-btn
    class="ma-0 pa-0"
    active-class="active-class"
    text
    min-width="0"
    href="https://eu-central-1.console.aws.amazon.com/cognito/users/?region=eu-central-1#/pool/eu-central-1_xK9v60GPR/details"
      >{{$t('navigation_bar.user_management')}}</v-btn>
  </div>
</template>

<script>
  import NavLink from "./NavLink";
  export default {
    name: "NavMenu",
    components: {
      NavLink
    },
  }
</script>

<style scoped>

</style>
